import React from 'react';

import { Meta, Navigation } from '$partials/global';
import * as Pages from './union/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').UnionPage}
 */
const UnionPage = (props) => {
    if (!props.data?.pageType || typeof (Pages[props.data?.pageType]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.data?.pageType];

    return (
        <>
            <Meta
                domain={props.domain}
                page={props.data?.page} />
            <Navigation navigation={props.data?.navigation} />
            <Component {...props} />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default UnionPage;
